import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { DossierSandboxService } from '@sc/data-access-state-management';
import { AuthService } from '@sc/feature-auth-okta';
import { map } from 'rxjs/operators';

export const FitterPageGuardCanActivate: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const dossierSB = inject(DossierSandboxService);
  const router = inject(Router);
  const authService = inject(AuthService);

  const redirectUrl = '/declaration/sinister-data';
  const dossierNumberExists = !!authService.getCurrentDossierId();

  return dossierSB.dossier$.pipe(
    map((dossier) => {
      return dossierNumberExists && !!dossier.customer && !!dossier.claim
        ? true
        : router.parseUrl(redirectUrl);
    })
  );
};
